import { render, staticRenderFns } from "./CrewChangeModal.vue?vue&type=template&id=537aa014"
import script from "./CrewChangeModal.vue?vue&type=script&lang=js"
export * from "./CrewChangeModal.vue?vue&type=script&lang=js"
import style0 from "./CrewChangeModal.vue?vue&type=style&index=0&id=537aa014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports